/**
 * Pads a string with leading zeros to make it up to the required length.
 * @param  {string} input - The input to pad.
 * @param  {number} length - The required length.
 */
export const padLeadingZeros = (input, length) => {
	let result = input + '';
	while (result.length < length) {
		result = '0' + result + '';
	}
	return result;
};
